import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { ErrorResponse, ServerError } from './ErrorResponse';
export class ClientErrorResponse {
    archiveMessage(texts) {
        return this.error.hasServerError(ServerError.FailedToArchiveCustomerDueToAgreement) ? texts.client.hasActiveOrCompletedAgreement() : this.error.hasServerError(ServerError.CannotArchiveDeletedCustomer) ? texts.client.deletedCannotArchive() : texts.client.errorArchiving();
    }
    deleteMessage(texts) {
        return this.error.hasServerError(ServerError.FailedToDeleteCustomerDueToAgreement) ? texts.client.hasAgreements() : texts.client.errorDeleting();
    }
    restoreMessage(texts) {
        return this.error.hasServerError(ServerError.CannotUnarchiveDeletedCustomer) ? texts.client.deletedCannotRestore() : texts.client.failedToRestore();
    }
    constructor(error){
        _define_property(this, "error", void 0);
        this.error = error instanceof ErrorResponse ? error : new ErrorResponse(error);
    }
}
